import backIcon from "./../../assets/volver.svg";
import { GoBackProps } from "./types";
import "./back.scss";
import "./i18n";
import { useTranslation } from "react-i18next";

const Back = ({ testId, onClick, id }: GoBackProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-testId={testId}
      id={id}
      className="back-container"
      onClick={onClick}
    >
      <img className="back-icon" src={backIcon} alt="back-icon" />
      <p className="back-text">{t("back:goBack")}</p>
    </div>
  );
};

export default Back;
